import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { termDataListDetailsProps } from "../TermDataReducer/TermDataSlice";

export interface employeeRewards {
  userId: string;
  employeeId: string;
  firstName: string;
  lastName: string;
  email: string;
  totalPoints: number;
  selectedReward: string | null;
  rewardAmount: number;
}

export interface employeePaginationData {
  pageNumber: number;
  totalPages: number;
  rowsPerPage: number;
}

interface rewardStateProps {
  eligibleForRewardsTab: string;
  termCodeValue: string;
  employee_rewards_data: employeeRewards[];
  employee_reward_PaginatedData: employeePaginationData;
  searchValue: string;
  employeeRewardsLoading: boolean;
  activeReward: termDataListDetailsProps | null;
}

let initialState: rewardStateProps = {
  eligibleForRewardsTab: "eligible",
  termCodeValue: "",
  employee_rewards_data: [],
  employee_reward_PaginatedData: {
    pageNumber: 1,
    totalPages: 1,
    rowsPerPage: 15,
  },
  searchValue: "",
  employeeRewardsLoading: false,
  activeReward: null,
};

const RewardSliceReducer = createSlice({
  name: "Reward",
  initialState,
  reducers: {
    setEligibleForRewardsTab(state, action: PayloadAction<string>) {
      state.eligibleForRewardsTab = action.payload;
    },
    setTermCodeValue(state, action: PayloadAction<string>) {
      state.termCodeValue = action.payload;
    },
    setEmployeeRewardData(state, action: PayloadAction<employeeRewards[]>) {
      state.employee_rewards_data = action.payload;
    },
    setEmployeeRewardPaginatedData(
      state,
      action: PayloadAction<employeePaginationData>,
    ) {
      state.employee_reward_PaginatedData = action.payload;
    },
    setSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },
    setEmployeeRewardsLoading(state, action: PayloadAction<boolean>) {
      state.employeeRewardsLoading = action.payload;
    },
    setActiveReward(
      state,
      action: PayloadAction<termDataListDetailsProps | null>,
    ) {
      state.activeReward = action.payload;
    },
  },
});

export const {
  setTermCodeValue,
  setEligibleForRewardsTab,
  setEmployeeRewardData,
  setEmployeeRewardPaginatedData,
  setSearchValue,
  setEmployeeRewardsLoading,
  setActiveReward,
} = RewardSliceReducer.actions;

export default RewardSliceReducer.reducer;
